import React, {useContext, useEffect, useState} from 'react';
import {FormInput} from "../../Form/Input/FormInput";
import './TypeVerificationCode.scss'
import {Button} from "../../Form/Button/Button";
import {buttonColors} from "../../Pickers/InputTheme";
import {UserReactContext} from "../../../contexts/UserContext";
import {get} from 'lodash'
import {requestAnother2fa} from "../../../Services/api";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import {I18nReactContext} from "../../../contexts/I18nContext";
import {LocalTabs} from "../../../Utils/RoutingTabs/Tabs";
import {Tooltip} from '@mui/material';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import {WhatsAppIcon} from '../../../Utils/SVGs/WhatsAppIcon';

export const TypeVerificationCode = ({linkLogin, deliveryMethod}) => {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const {i18n, isRtl} = useContext(I18nReactContext);
    const userContext = useContext(UserReactContext);
    const hasEmail = get(userContext, 'user.maskedEmail');
    const hasPhone = get(userContext, 'user.last4digits');
    const [preStep, setPreStep] = useState(linkLogin);
    const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState(linkLogin ? (hasPhone ? 'phone' : 'email') : deliveryMethod);
    
    const handleChange = (event) => {
        const value = event.target.value;
        if (value.length <= 6) {
            setCode(value);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!code || code.length < 6) {
            setError(i18n.translate('login.verificationCodeFromSMS'));
        } else {
            userContext.validateMFA({code});
        }
    }

    const requestAnother2faCode = async () => {
        setLoading(true)
        const {valid} = await requestAnother2fa({deliveryMethod: selectedDeliveryMethod})
        setLoading(false)
        setPreStep(false)
    }

    // Check if user has email and phone
   

    const handleTabChange = (newTabValue) => {
        setSelectedDeliveryMethod(newTabValue);
    }

    const handleSendCode = async () => {
        if ((['phone', 'whatsapp'].includes(selectedDeliveryMethod) && !hasPhone) ||
            (selectedDeliveryMethod === 'email' && !hasEmail)) {
            return;
        }
        await requestAnother2faCode();
    }

    const deliveryTabs = [
        {
            value: 'phone',
            label: i18n.translate('login.sendBySMS'),
            icon: <SmsOutlinedIcon sx={{color: 'black'}} />
        },
        {
            value: 'whatsapp',
            label: i18n.translate('login.sendByWhatsApp'),
            icon: <WhatsAppIcon width="24" height="24" color="black" />
        },
        {
            value: 'email',
            label: i18n.translate('login.sendByEmail'),
            icon: <MailOutlineIcon sx={{color: 'black'}} />
        }
    ];

    if (preStep) {
        return <div className={`TypeVerificationCode ${isRtl ? 'rtl' : 'ltr'}`}>
            <div className="greeting-section">
                <div className="user-greeting">
                    {i18n.translate('login.helloX', {context: {name: get(userContext, 'user.firstName')}})}
                </div>
                <div className="instruction-text">
                    {i18n.translate('login.chooseVerificationMethod')}
                </div>
            </div>
            
            <div className="otp-delivery-tabs">
                <LocalTabs 
                    tabs={deliveryTabs} 
                    defaultTab={selectedDeliveryMethod} 
                    variant="fullWidth" 
                    scrollButtons={false} 
                    onTabChange={handleTabChange}
                />
            </div>
            
            <div className="login-btn-wrapper">
                <Tooltip
                    title={(selectedDeliveryMethod === 'phone' && !hasPhone) ? i18n.translate('login.noPhoneContactManager') :
                          (selectedDeliveryMethod === 'email' && !hasEmail) ? i18n.translate('login.noEmailContactManager') :
                          (selectedDeliveryMethod === 'whatsapp' && !hasPhone) ? i18n.translate('login.noPhoneContactManager') : ''}
                    arrow
                    placement="top"
                >
                    <span>
                        <Button
                            color={buttonColors.GREY}
                            type="submit"
                            style={{width: '100%'}}
                            text={i18n.translate('login.sendCode')}
                            onClick={handleSendCode}
                            disabled={(selectedDeliveryMethod === 'phone' && !hasPhone) ||
                                     (selectedDeliveryMethod === 'email' && !hasEmail) ||
                                     (selectedDeliveryMethod === 'whatsapp' && !hasPhone)}
                            data-testid={`send-code-${selectedDeliveryMethod}`}
                        />
                    </span>
                </Tooltip>
            </div>
        </div>
    }

    return (
        <div className={`TypeVerificationCode ${isRtl ? 'rtl' : 'ltr'}`}>
            <FormInput
                error={error}
                dontShowErrorMessage
                required
                id="identifier"
                label={i18n.translate('login.verificationCodeFromSMS')}
                className="login-text-field first"
                value={code}
                onChange={handleChange}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        handleSubmit(e);
                    }
                }}
                type="number"
                inputProps={{
                    maxLength: 6,
                    inputMode: 'numeric',
                    pattern: '[0-9]*'
                }}
            />
            <div className="sendAgainAndTextWrapper">
                <div
                    className="messageSentText">
                    {selectedDeliveryMethod === 'email' && get(userContext, 'user.maskedEmail') ?
                        i18n.translate('login.messageWasSentToEMAIL', {context: {maskedEmail: get(userContext, 'user.maskedEmail')}}) :
                        selectedDeliveryMethod === 'phone' && get(userContext, 'user.last4digits') ?
                            i18n.translate('login.messageWasSentToSMS', {context: {last4digits: get(userContext, 'user.last4digits')}}) :
                        selectedDeliveryMethod === 'whatsapp' && get(userContext, 'user.last4digits') ?
                            i18n.translate('login.messageWasSentToWhatsApp', {context: {last4digits: get(userContext, 'user.last4digits')}}) :
                            ''
                    }
                </div>
                <div className="tryAgain" onClick={requestAnother2faCode}>{i18n.translate('login.resendCode')}</div>
            </div>
            <div className={`spamMessage ${isRtl ? 'rtl' : 'ltr'}`} >
                {i18n.translate('login.checkSpamMessage')}
                <div className="spamFolder">
                    {i18n.translate('login.spamFolder')}
                </div>
            </div>
            <div className="login-btn-wrapper">
                <Button color={buttonColors.GREY} type="submit" style={{width: '100%'}}
                        disabled={!code || code.length < 6}
                        text={i18n.translate('login.validate')} onClick={handleSubmit} value="Login"/>
            </div>
            {loading ? <LoadingSpinner/> : null}
        </div>
    );
};

